import { RestService } from "@sinossi/mates-react-library";

export class MicrojobServices {

    static filterMicrojobs = (request: any, callback: any, catchCallback: any) => {
        RestService
            .post<any>(`/api/microjobs/filter`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static createMicrojob = (request: any, callback: any, catchCallback: any) => {
        RestService
            .post<any>(`/api/microjobs/`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static getUserMicrojobs = (request: any, callback: any, catchCallback: any) => {
        RestService
            .post<any>(`/api/microjobs/mine`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static getAvailableMicrojobs = (request: any, callback: any, catchCallback: any) => {
        RestService
            .post<any>(`/api/microjobs/available`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static takeMicrojob = (microjobId: string, callback: any, catchCallback: any) => {
        RestService
            .put<any>(`/api/microjobs/${microjobId}/take`, {})
            .then(callback)
            .catch(catchCallback)
    }

    static concludeMicrojob = (microjobId: string, request: any, callback: any, catchCallback: any) => {
        RestService
            .put<any>(`/api/microjobs/${microjobId}/conclude`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static confirmMicrojob = (microjobId: string, callback: any, catchCallback: any) => {
        RestService
            .put<any>(`/api/microjobs/${microjobId}/confirm`, null)
            .then(callback)
            .catch(catchCallback)
    }
}
